<div class="tpd-dialog">

    <!-- Header -->
    <div class="tpd-dialog__header">
        <div class="tpd-dialog__title">
            <img class="tpd-dialog__title-icon" src="assets/hamIcons/search-outline.svg" alt="" />
            <span>{{ 'aumico_ai_taxonomy_preview_title' | i18next }}</span>
        </div>
        <button class="tpd-dialog__close-btn" (click)="close()" [title]="'aumico_ai_taxonomy_preview_close' | i18next">
            <img src="assets/hamIcons/close-icon.svg" alt="" />
        </button>
    </div>

    <!-- Tabs -->
    <div class="tpd-dialog__tabs">
        <button
            *ngFor="let tab of tabs; let i = index"
            class="tpd-dialog__tab"
            [class.tpd-dialog__tab--active]="i === activeTabIndex"
            (click)="selectTab(i)">
            {{ tab.label | i18next }}
            <span class="tpd-dialog__tab-count">{{ tab.rows.length }}</span>
        </button>
    </div>

    <!-- Content -->
    <div class="tpd-dialog__body" *ngIf="tabs[activeTabIndex] as tab">

        <!-- Tree-updated flash indicator -->
        <div *ngIf="treeUpdatedFlash" class="tpd-dialog__updated-flash">
            {{ 'aumico_ai_taxonomy_preview_tree_updated' | i18next }}
        </div>

        <div class="tpd-dialog__table-header">
            <span class="tpd-dialog__col-num">No.</span>
            <span class="tpd-dialog__col-name">Name</span>
        </div>

        <div class="tpd-dialog__scroll-area">
            <div
                *ngFor="let row of tab.rows"
                class="tpd-node"
                [class.tpd-node--group]="row.isGroup"
                [class.tpd-node--dash]="row.isDash"
                [style.paddingLeft]="getIndentPx(row.level)">

                <span class="tpd-node__num" [class.tpd-node__num--empty]="!row.numberLabel">
                    {{ row.numberLabel || '' }}
                </span>

                <span class="tpd-node__name" [class.tpd-node__name--group]="row.isGroup">
                    {{ row.itemText }}
                    <span class="tpd-node__badge" [ngClass]="getBadgeClass(row.classification)">
                        {{ getClassificationKey(row.classification) | i18next }}
                    </span>
                </span>
            </div>

            <div *ngIf="tab.rows.length === 0" class="tpd-dialog__empty">
                {{ 'aumico_ai_taxonomy_preview_no_entries' | i18next }}
            </div>
        </div>
    </div>

    <!-- Chat Panel -->
    <div class="tpd-chat" *ngIf="hasSession">
        <div class="tpd-chat__messages" #chatMessagesContainer>
            <div *ngIf="chatMessages.length === 0 && !isSending" class="tpd-chat__placeholder">
                {{ 'aumico_ai_taxonomy_preview_chat_placeholder' | i18next }}
            </div>
            <div
                *ngFor="let msg of chatMessages"
                class="tpd-chat__bubble"
                [class.tpd-chat__bubble--user]="msg.role === 'user'"
                [class.tpd-chat__bubble--agent]="msg.role === 'agent'">
                <span class="tpd-chat__role">{{ msg.role === 'user' ? ('aumico_ai_taxonomy_preview_chat_you' | i18next) : ('aumico_ai_taxonomy_preview_chat_ai' | i18next) }}</span>
                <span class="tpd-chat__text">
                    <ng-container *ngIf="msg.contentKey; else rawContent">
                        {{ msg.contentKey | i18next: (msg.contentParams || {}) }}
                    </ng-container>
                    <ng-template #rawContent>{{ msg.content }}</ng-template>
                </span>
            </div>

            <!-- Progress feed: shows live tool calls while the agent works -->
            <div *ngIf="isSending" class="tpd-chat__progress">
                <div class="tpd-chat__progress-header">
                    <span class="tpd-chat__progress-spinner"></span>
                    <span>{{ 'aumico_ai_taxonomy_preview_agent_working' | i18next }} ({{ chatProgressEvents.length }} {{ (chatProgressEvents.length !== 1 ? 'aumico_ai_fixer_progress_steps' : 'aumico_ai_fixer_progress_step') | i18next }})</span>
                </div>
                <div class="tpd-chat__progress-log" *ngIf="chatProgressEvents.length > 0">
                    <div
                        *ngFor="let evt of chatProgressEvents; let i = index; let last = last"
                        class="tpd-chat__progress-entry"
                        [class.tpd-chat__progress-entry--latest]="last">
                        <span class="tpd-chat__progress-idx">{{ i + 1 }}.</span>
                        <span class="tpd-chat__progress-text">
                            <ng-container *ngIf="evt.messageKey; else rawProgress">
                                {{ evt.messageKey | i18next: (evt.messageParams || {}) }}
                            </ng-container>
                            <ng-template #rawProgress>{{ formatProgressEvent(evt) }}</ng-template>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="tpd-chat__input-row">
            <input
                class="tpd-chat__input"
                type="text"
                [(ngModel)]="chatInput"
                (keydown)="onChatKeydown($event)"
                [placeholder]="'aumico_ai_taxonomy_preview_type_message' | i18next"
                [disabled]="isSending" />
            <button
                class="tpd-chat__send-btn"
                (click)="sendMessage()"
                [disabled]="isSending || !chatInput.trim()"
                [title]="'aumico_ai_taxonomy_preview_send' | i18next">
                <img src="assets/hamIcons/arrow-right.svg" alt="" />
            </button>
        </div>
    </div>
</div>
